type MarketLogoProps = {
  className?: string;
};

export function MarketLogo({ className = '' }: MarketLogoProps) {
  return (
    <svg
      className={className}
      width="42"
      height="42"
      viewBox="0 0 42 42"
      role="img"
      aria-label="Market Terminal"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="4.5"
        y="5.5"
        width="33"
        height="31"
        rx="8"
        className="market-logo__frame"
      />

      <circle cx="12" cy="13" r="1.8" className="market-logo__dot" />
      <circle cx="18" cy="13" r="1.8" className="market-logo__dot" />
      <circle cx="24" cy="13" r="1.8" className="market-logo__dot" />

      <path
        d="M10 28.5L16 22.6L20.5 25.9L27.5 17.8L32 20.8"
        className="market-logo__line"
      />

      <path
        d="M27.5 17.8H32V22.3"
        className="market-logo__line"
      />
    </svg>
  );
}